import React, { useEffect, useState } from "react";
import { Routes, Route, BrowserRouter } from "react-router-dom";
import Home from "./components/home/Home";
import Login from "./components/login/Login";
import "./App.css";
import AdminPage from "./components/adminPage/AdminPage";
import ClientPage from "./components/clientPage/ClientPage";
import { ChakraProvider } from "@chakra-ui/react";

const App = () => {
    const [user,setUser] = useState()
    useEffect(()=>{
      const a = localStorage.getItem("userInfo")
      setUser(a)
    },[])
  return (
    <ChakraProvider>
      <div className="App">
        <BrowserRouter>
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="login" element={<Login user={user} setUser={setUser}/>} />
            <Route path="adminPage" element={<AdminPage user={user}/>} />
            <Route path="clientPage" element={<ClientPage user={user}/>} />
          </Routes>
        </BrowserRouter>
      </div>
    </ChakraProvider>
  );
};

export default App;
